<template>
  <transition name="modal">
    <div
        class="modal-mask w-full h-full flex flex-wrap items-center justify-center overflow-y-auto py-4"
        @click.self="$emit('closeOnOverlay')"
    >
      <div class="modal-wrapper flex-1">
        <slot name="modal-wrapper">
          <div :class="modalClasses">
            <div v-if="closeIcon" class="flex justify-end">
              <button
                  class="transform hover:rotate-90 transition-transform duration-500 ease-out w-10 h-10 text-gray-600"
                  @click="$emit('close')"
              >
                <CloseIcon/>
              </button>
            </div>

            <slot name="modal-content">
              <div class="modal-header">
                <slot name="header"></slot>
              </div>
              <div class="modal-body">
                <slot name="body"></slot>
              </div>
              <div class="modal-footer">
                <slot v-if="!withoutFooter" name="footer">
                  <div class="text-center">
                    <button
                        class="btn btn-primary font-semibold rounded-lg px-12 mx-auto"
                        @click="$emit('close')"
                    >
                      OK
                    </button>
                  </div>
                </slot>
              </div>
            </slot>
          </div>
        </slot>
      </div>
    </div>
  </transition>
</template>

<script>
import CloseIcon from '@/components/common/icons/CloseIcon'

export default {
  name      : 'Modal',
  components: {
    CloseIcon,
  },

  props: {
    size         : {
      required: false,
      default : 'sm'
    },
    withoutFooter: {
      required: false,
      default : false
    },
    closeIcon    : {
      required: false,
      default : false
    }
  },

  computed: {
    modalClasses () {
      let c =
              'modal-container mx-2 sm:mx-auto bg-white rounded-lg shadow-card px-1 sm:px-8 py-5 transition-all duration-200 relative'

      if (this.size === 'sm') {
        c = c + ' max-w-3xl'
      } else if (this.size === 'md') {
        c = c + ' max-w-5xl'
      } else if (this.size === 'lg') {
        c = c + ' max-w-8xl'
      }

      return c
    }
  },
  created () {
    this.$store.commit('setIsModalActive', true)
  },
  destroyed () {
    this.$store.commit('setIsModalActive', false)
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

.modal-container {
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
